import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { styled } from 'styled-components';

import { textColors } from '../../../theme/palette';
import { Text } from '../../Text';

import type { FeedbackIntent, FeedbackProps } from './types';

type CaptionProps = Omit<ComponentPropsWithoutRef<typeof Text>, 'variant'> & FeedbackProps;

const Caption = forwardRef<HTMLElement, CaptionProps>(({ ...props }, ref) => (
  <Text {...props} ref={ref as any} variant="caption" />
));

const colorByIntent = (intent: FeedbackIntent): string => {
  switch (intent) {
    case 'danger':
      return textColors.danger;
    case 'warning':
      return textColors.warning;
    case 'help':
    default:
      return textColors.disabled;
  }
};

const StyledCaption = styled(Caption)<CaptionProps>`
  display: block;
  color: ${({ intent }) => colorByIntent(intent)};
`;

/* Give the icon a line-box equal to the caption line-height and center it inside, so it stays
   vertically aligned with the text. The row keeps align-items: flex-start, so the icon lines up
   with the first line of text even when the message wraps onto several lines. */
const IconBox = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  height: ${({ theme }) => theme.designTokens.textCaptionLineHeight};
`;

export const Styled = {
  Caption: StyledCaption,
  IconBox,
};
